import { render, staticRenderFns } from "./ProjectButtons.vue?vue&type=template&id=264e6592&lang=html"
import script from "./ProjectButtons.vue?vue&type=script&lang=js"
export * from "./ProjectButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports